<template>
  <div>
    <v-list-item v-for="(item, index) in items" :key="index">
      <v-list-item-content style="flex: none">
        <v-list-item-title class="d-flex align-center mr-2">
          <v-icon class="mr-2">{{ item.icon }}</v-icon>
          {{ item.title }}:
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-content class="text-right flex-grow-1">
        <v-list-item-title v-if="item.href" class="showAllText">
          <a :href="item.href" :target="item.target">
            {{ item.content }}
          </a>
        </v-list-item-title>
        <v-list-item-title :class="{ showAllText: item.showAllText }" v-else>
          {{ item.content }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script lang="ts">
class listObject {
  icon?: string;
  title?: string;
  content?: string;
  showAllText?: boolean;
}

import Vue from "vue";
export default Vue.extend({
  props: {
    value: {
      type: Array as () => Array<listObject>,
      required: true,
    },
  },
  computed: {
    items: {
      get(): Array<listObject> {
        return this.value;
      },
    },
  },
});
</script>

<style lang="scss" scoped>
.showAllText {
  white-space: inherit;
}
</style>
